/**
 * A small moored skiff (lifted from lantern-water's `world.js` `createTown`):
 * a hull of planks with pointed ends, two thwarts and an oar. Origin at the
 * boat's centre (the prototype's 6.45, 5.8, on the water at -0.54). No params.
 */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'skiff',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, line, m } = ctx;
    box(root, 0, 0, 0, 1, 0.15, 2.4, m.darkWood);
    for (const s of [-1, 1]) {
      box(root, s * 0.48, 0.19, 0, 0.1, 0.42, 2.4, m.wood);
      line(root, [s * 0.48, 0.2, 1.2], [0, 0.2, 1.6], 0.12, m.wood);
      line(root, [s * 0.48, 0.2, -1.2], [0, 0.2, -1.6], 0.12, m.wood);
    }
    for (const z of [-0.6, 0.5]) box(root, 0, 0.31, z, 1, 0.08, 0.3, m.wood);
    line(root, [-0.9, 0.4, -0.8], [0.6, 0.4, 1.1], 0.065, m.wood);
    return { root };
  },
};
